<template>
  <div>
    <router-view />
  </div>
</template>


<script>
export default {
  name: "App",
};
</script>

<style>

body {
  font-family: 'IRANSans' !important;
}

/* @import url('https://cdn.jsdelivr.net/gh/rastikerdar/vazirmatn/Vazirmatn-font-face.css'); */
</style>